<template>
    <li class="attendee d-flex">
        <div class="status flex-shrink-0">
            <font-awesome-icon v-if="attendee.status === 'attending'" class="text-success" icon="check" />
            <font-awesome-icon v-else-if="attendee.status === 'absent'" class="text-danger" icon="times" />
        </div>
        <div class="flex-grow-1 text-truncate">
            {{ identifier }}
        </div>
        <div class="controls flex-shrink-0">
            <button v-on:click="onAttend" class="btn btn-link text-secondary"><font-awesome-icon icon="check" /></button>
            <button v-on:click="onAbsent" class="btn btn-link text-secondary"><font-awesome-icon icon="times" /></button>
        </div>
    </li>
</template>

<script>
import _ from 'underscore';

export default {
    name: 'attendee',
    props: ['attendee'],
    computed: {
        identifier() {
            const data = this.attendee.data;
            if (!data || data.length === 0) return this.attendee.identifier;
            return data.join(', ');
        },
    },
    methods: {
        onAttend: function () {
            const attendee = _.extend({}, this.attendee, { status: 'attending' });
            this.$store.dispatch('updateAttendee', attendee);
        },
        onAbsent: function () {
            const attendee = _.extend({}, this.attendee, { status: '' });
            this.$store.dispatch('updateAttendee', attendee);
        },
    }
};
</script>

<style lang="scss">
    .attendee {
        margin-bottom: 7px;

        .status {
            min-width: 1.6rem;
        }

        .controls button {
            padding-top: 0;
            padding-bottom: 0;
            border: 0;

            @media (max-width: 575px) {
                padding-left: 6px;
                padding-right: 6px;
            }
        }
    }
</style>